import axios from 'axios'

const ApprovalService = {
  async get (params = {}) {
    return axios.get('wo/purchase-order/approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('wo/reports/purchase-order/approval-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('wo/exports/purchase-order/approvals', { params })
  },

  async show (id) {
    return axios.get(`wo/purchase-order/approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/purchase-order/approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/purchase-order/approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/purchase-order/approvals/${data.id}`, { data })
  }
}

export default ApprovalService
